
const imgUrl = {
    
    'endlogo' : require('./end_tb_logo.png'),
    'durelogo' : require('./durelogo.png'),
    'avatar': require('./avatar.png'),
    'pgmico': require('./pgmico.png'),
}

export default imgUrl;